import { FC, useId } from 'react';
import styles from './PulseLogo.module.scss';

export interface PulseLogoProps {
  variant?: 'full' | 'mark' | 'stamp';
  theme?: 'dark' | 'light';
  className?: string;
}

export const PulseLogo: FC<PulseLogoProps> = ({
  variant = 'full',
  theme = 'dark',
  className = '',
}) => {
  const gradId = useId();

  if (variant === 'mark') {
    return (
      <svg
        className={`${styles.logoMark} ${className}`}
        viewBox="0 0 40 40"
        aria-label="Pulse logo mark"
        width="36"
        height="36"
      >
        <defs>
          <linearGradient id={gradId} x1="0" x2="1" y1="0" y2="0">
            <stop offset="0%" stopColor="#30bbb8" />
            <stop offset="100%" stopColor="#00a2b1" />
          </linearGradient>
        </defs>
        <path
          d="M4 22h7l4-6 5 15 6-27 6 22 4-7h4"
          fill="none"
          stroke={`url(#${gradId})`}
          strokeWidth="3.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="4" cy="22" r="2" fill="#30bbb8" />
      </svg>
    );
  }

  if (variant === 'stamp') {
    return (
      <svg
        className={`${styles.logoStamp} ${className}`}
        viewBox="0 0 115 36"
        aria-label="Pulse logo stamp"
        width="100"
        height="32"
      >
        <path
          d="M8 20h8l4-5 6 15 7-27 7 21 4-7h8"
          fill="none"
          stroke="currentColor"
          strokeWidth="3.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="8" cy="20" r="2" fill="currentColor" />
        <text
          x="58"
          y="25"
          fontFamily="Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
          fontWeight="760"
          fontSize="20"
          letterSpacing="-0.6px"
          fill="currentColor"
        >
          Pulse
        </text>
      </svg>
    );
  }

  const textColor = theme === 'dark' ? '#ffffff' : '#102b4d';

  return (
    <svg
      className={`${styles.logoFull} ${className}`}
      viewBox="0 0 175 44"
      aria-label="Pulse Waveform Logo"
      width="160"
      height="40"
    >
      <defs>
        <linearGradient id={gradId} x1="0" x2="1" y1="0" y2="0">
          <stop offset="0%" stopColor="#30bbb8" />
          <stop offset="100%" stopColor="#00a2b1" />
        </linearGradient>
      </defs>
      <path
        d="M10 24h10l5-6 7 15 8-27 8 21 5-7h11"
        fill="none"
        stroke={`url(#${gradId})`}
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="10" cy="24" r="2.2" fill="#30bbb8" />
      <text
        x="82"
        y="31"
        fontFamily="Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
        fontWeight="760"
        fontSize="24"
        letterSpacing="-0.8px"
        fill={textColor}
      >
        Pulse
      </text>
    </svg>
  );
};
